/**
 * Requested sudoku difficulty, mirroring the backend SudokuDifficultyRequest enum.
 * MIXED produces an equal share of each level within a puzzle set.
 */
export type SudokuDifficulty = 'EASY' | 'MEDIUM' | 'HARD' | 'MIXED';

/**
 * Selector options in display order.
 */
export const SUDOKU_DIFFICULTY_OPTIONS: SudokuDifficulty[] = ['EASY', 'MEDIUM', 'HARD', 'MIXED'];

export const SUDOKU_DIFFICULTY_LABELS: Record<SudokuDifficulty, string> = {
  EASY: 'Легкая',
  MEDIUM: 'Средняя',
  HARD: 'Высокая',
  MIXED: 'Микс',
};
